import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid, scopedCssBaselineClasses, Container } from '@mui/material'
import { findCode, printVariable } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import useAlert from '@hooks/useAlert'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import Box from '@mui/material/Box'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import '@scss/App.scss'
import consoleLogger from 'react-terminal-logger/console-logger'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles';
import { LineCart, LineChart, } from '@mui/x-charts/LineChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import { useAnimate, useAnimateBar, useDrawingArea } from '@mui/x-charts/hooks';
import { PiecewiseColorLegend } from '@mui/x-charts/ChartsLegend';
import { interpolateObject } from '@mui/x-charts-vendor/d3-interpolate';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManagerSurveyPartIndi from './manager-survey.part.indi'
import * as ExcelJS from 'exceljs'
import ExcelExporter from '@components/ExcelExporter'
import { transformToMatrix } from './manager-survey.part.indi'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';

const ManagerSurveyPartStat = ({ record, dialogHandler, tabValue, callback }) => {
  const [quests, set_quests] = useState([])
  const [surveySum, set_surveySum] = useState([])
  const [openSnackbar] = useSnackbar()
  const [replUserCnt, set_replUserCnt] = useState()
  const [subjRepls, set_subjRepls] = useState([])
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const detailHandler = useState(false)

  const schola = useSelector(state => state.scholaReducer);
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      dialogHandler[1](false)
    }
  }

  const fillSheet1 = (workbook) => {

    const exporter = new ExcelExporter(workbook, "분석")
    exporter.setValue('전체 응답자수').nextCol()
    exporter.setValue(replUserCnt).nextCol()
    exporter.jumpTo(exporter.rownum + 1, 1)

    quests.forEach(quest => {
      exporter.setValue(`Q.${quest.sqNum} ${quest.txt}`)
      exporter.nextRow()
      const rows = surveySum.filter(r => r.questId === quest.id)
      const rowTotal = rows.reduce((sum, r) => sum + r.ansCnt, 0)
      exporter.setValue('응답:').nextCol()
      exporter.setValue(`${rowTotal}`)
      exporter.jumpTo(exporter.rownum + 1, 1)

      if (quest.questCode === 'Q000' || quest.querstCode === 'Q001') {
        quest.anss.forEach(ans => {
          exporter.setValue(`${ans.txt}`).nextCol()
          console.log('questCode=>', quest.questCode)
          const found = surveySum.find(s => s.questId === quest.id && s.ansId === ans.id)
          if (found) {
            exporter.setValue(`${found.ansCnt}`).nextCol()
            if (found.ansCnt > 0) {
              exporter.setValue(`${(100 * Number(found.ansCnt) / Number(rowTotal)).toFixed(1)} %`).nextCol()
            }
          }
          exporter.jumpTo(exporter.rownum + 1, 1)
        })

      }
      else if (quest.questCode === 'Q002') {
        subjRepls.filter(r => r.questId === quest.id).forEach((repl) => {
          exporter.setValue(repl.txt)
          exporter.nextRow()
        })
      }

      exporter.nextRow()
    })
  }

  const fillSheet2 = (workbook, data) => {
    console.log('data=>', data)
    const { headers, rows } = data
    const exporter = new ExcelExporter(workbook, "상세")
    exporter.setValue('순번').nextCol()
    exporter.setValue('전화번호').nextCol()

    headers.forEach(header => {
      exporter.setValue(header).nextCol()
    })

    exporter.jumpTo(exporter.rownum + 1, 1)

    rows.forEach((row, rowIdx) => {
      exporter.setValue(rowIdx + 1).nextCol()
      exporter.setValue(row.userId).nextCol()
      row.data.forEach((cell, cellIdx) => {
        exporter.setValue(cell.value).nextCol()
      })

      exporter.jumpTo(exporter.rownum + 1, 1)
    })
  }

  const handleDownload = async () => {
    const data = await fetchSurveyDetail()
    if (!data) {
      return
    }

    const workbook = new ExcelJS.Workbook()
    fillSheet1(workbook)
    fillSheet2(workbook, data)


    workbook.xlsx.writeBuffer().then(buffer => {
      let filename = `${schola.name}_${record.title}`

      filename = filename + `.xlsx`
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    })
  }

  const fetchSurveyDetail = async () => {
    const url = `/survey/detail/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const surveyDetail = JSON.parse(repMessage.surveyDetail)


    const { headers, rows } = transformToMatrix(surveyDetail)
    return ({
      headers: headers,
      rows: rows,
    })
  }

  const fetchQuests = async () => {
    if (record.id === -1) {
      return
    }

    const url = `/survey/${record.id}`
    openIndicator()
    const resp = await WebService.get(url, {
      useYn: 'A'
    })
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    if (records?.length > 0) {
      const quests = records[0].quests
      set_quests(quests)
    }
  }


  const fetchSum = async () => {
    const url = `/survey/sum/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const replUserCnt = Number(repMessage.replUserCnt)
    const subjRepls = JSON.parse(repMessage.subjRepls)

    set_subjRepls(subjRepls)
    set_replUserCnt(replUserCnt)
    set_surveySum(records)
  }

  const onLoad = async () => {
    await fetchQuests()
    await fetchSum()
  }


  const MyPie = ({ questId }) => {
    const rows = surveySum.filter(r => r.questId === questId)
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0)

    const data = rows.map(r => {
      const txt = quests.find(q => q.id === questId)?.anss?.find(a => a.id === r.ansId)?.txt;
      // If total is 0, give it a tiny value so the label exists, but color it grey
      const isNoData = total === 0

      const dataItem = {
        id: r.ansId,
        value: isNoData ? 1 : r.ansCnt,
        label: txt || `Ans ${r.ansId}(삭제된 선택지)`,
        formattedLabel: isNoData ? '0 (0%)' : `${r.ansCnt} ( ${((r.ansCnt / total) * 100).toFixed(1)}%)`
      }

      if (isNoData) {
        dataItem.color = '#eeeeee';
      }
      return dataItem
    });

    const series = [
      {
        data: data,
        arcLabel: (item) => item.formattedLabel,
        arcLabelMinAngle: 35, // Only show label if slice is big enough
        highlightScope: { faded: 'global', highlighted: 'item' },
      },
    ]

    return (
      <>
        <Typography variant='body2'>응답:{total}</Typography>
        <PieChart
          series={series}
          sx={{
            [`& .MuiPieArcLabel-root`]: {
              fill: 'white',
              fontWeight: 'bold',
              fontSize: 12,
            },
          }}
          width={500}
          height={200}
        />
        {/* {
          total == 0 ? (
            <Typography>이 질문에 응답이 없습니다.</Typography>
          ) : null
        } */}
      </>

    )
  }

  const MyBar = ({ questId }) => {
    const rows = surveySum.filter(r => r.questId === questId)
    console.log('MyBar rows count:', rows.length);
    if (!surveySum.length || rows.length === 0) {
      return <div style={{ height: 200 }}>Loading Chart Data...</div>;
    }
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0);
    const axisData = rows.map(r => {
      // 답변 하나가 한 그룹
      const txt = quests.find(q => q.id === questId)?.anss?.find(a => a.id === r.ansId)?.txt
      return txt || '삭제된 선택지'
      // return quests.find(q => q.id === questId)?.anss?.find(a => a.id === r.ansId)?.txt
    })

    const seriesData = [
      {
        data: rows.map(r => r.ansCnt),

        // label: '응답수' 
        valueFormatter: (value) => {
          const percent = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
          return `${value} views (${percent}%)`;
        },
      }
    ]
    console.log('axisData=>', axisData)
    console.log('seriesData=>', seriesData)

    return (
      <>
        <Typography variant='body2'>응답:{total}</Typography>
        <BarChart
          yAxis={[{
            scaleType: 'band',
            data: axisData,
          }]}
          xAxis={[{
            type: 'number',
            // Force the chart to show a bit of space before the first bar
            // min: -0.01, 
            // Ensure the max value has room for the text labels
            // max: total > 0 ? total + (total * 0.2) : 10 
          }]}
          layout="horizontal"
          series={seriesData}
          barLabel={(item) => {
            if (item.value === 0) return null;
            const percent = total > 0 ? ((item.value / total) * 100).toFixed(0) : 0;
            return `${item.value} (${percent}%)`;
          }}

          height={200}
          width={500}
          margin={{ left: 150, right: 80 }}
        />
        {/* {
          total === 0 ? (
             <Typography>이 질문에 응답이 없습니다.</Typography>
          ) : null
        } */}
      </>

    )
  }

  const MyAccordion = ({ questId }) => {
    console.log('questId=>', questId)
    const rows = surveySum.filter(r => r.questId === questId)
    console.log('rows=>', rows)
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0);
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }} gap={1}>
        <Typography variant='body2'>응답:{total}</Typography>
        <Grid container>
          <Grid item xs={12}>
            <Accordion
            >
              <AccordionSummary
                id={`repl-${questId}`}
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: '#fafafa', // 필요시 배경색 살짝 추가
                }}
              >
                응답내용
              </AccordionSummary>
              <AccordionDetails>
                {
                  subjRepls.filter(r => r.questId === questId).map((repl) => (
                    <Typography key={`repl-${questId}-${repl.id}`}>{repl.txt}</Typography>
                  ))
                }
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>

      </Box>

    )
  }

  useEffect(() => {
    onLoad()
  }, [])
  return (
    <Fragment>
      <div>
        {renderIndicator()}
        {renderAlert()}
        {detailHandler[0] ? (<ManagerSurveyPartIndi record={record} dialogHandler={detailHandler} callback={onLoad} />) : null}
      </div>
      <Dialog open={dialogHandler[0]} onClose={handleClose} fullScreen>
        <DialogTitle>
          <Grid container>
            <Grid item xs></Grid>
            <Grid item xs={10}>
              <Box className={'center'}>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  {schola.name}
                </Typography>

                <Typography variant="h5" sx={{ fontWeight: 'bold' }} align="center">
                  {record.title}
                </Typography>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  분석
                </Typography>

              </Box>
            </Grid>
            <Grid item xs style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

        </DialogTitle>
        <DialogContent>
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {
                  replUserCnt ? (
                    <Box style={{ display: 'flex', alignItems: 'center' }} gap={2}>
                      <PeopleAltOutlinedIcon />
                      <Typography style={{ fontWeight: 'bold' }} variant={'h6'}>전체 응답자수: {replUserCnt}</Typography>
                      <Button
                        startIcon={<AssignmentOutlinedIcon />}
                        onClick={() => {
                          detailHandler[1](true)
                        }}
                      >
                        상세보기
                      </Button>
                      <Button
                        startIcon={<FileDownloadOutlinedIcon />}
                        onClick={() => {
                          handleDownload()
                        }}
                      >
                        다운로드
                      </Button>
                    </Box>

                  ) : null
                }

              </Grid>
              {
                quests.map((quest, idx) => (
                  <Grid item xs={12} key={idx}>
                    <Typography style={{ fontWeight: 'bold' }}>{`Q ${quest.sqNum}. ${quest.txt}`}</Typography>
                    {
                      quest.questCode === 'Q000' ? (
                        <MyPie questId={quest.id} />
                      ) : quest.questCode === 'Q001' ? (
                        <MyBar questId={quest.id} />
                      ) : (
                        <MyAccordion questId={quest.id} />
                      )

                    }
                  </Grid>
                ))
              }

            </Grid>
          </Container>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleClose}>닫기</Button>
        </DialogActions>
      </Dialog>

    </Fragment>
  )
}

export default ManagerSurveyPartStat